/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Type_Physio_Consultation_TermsInputs */

const en_service_type_physio_consultation_terms = /** @type {(inputs: Service_Type_Physio_Consultation_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`physiotherapist, physio, physical therapy, assessment, first visit, pain`)
};

const pl_service_type_physio_consultation_terms = /** @type {(inputs: Service_Type_Physio_Consultation_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`fizjoterapeuta, fizjoterapia, fizjo, rehabilitant, diagnostyka, pierwsza wizyta, badanie, ból`)
};

/**
* | output |
* | --- |
* | "physiotherapist, physio, physical therapy, assessment, first visit, pain" |
*
* @param {Service_Type_Physio_Consultation_TermsInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const service_type_physio_consultation_terms = /** @type {((inputs?: Service_Type_Physio_Consultation_TermsInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Type_Physio_Consultation_TermsInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_service_type_physio_consultation_terms(inputs)
	return en_service_type_physio_consultation_terms(inputs)
});